import {
	Icon,
	Card, Button, HStack,

} from '@chakra-ui/react';
import type { CardRootProps } from '@chakra-ui/react';
import React from 'react';
import { IoSearchSharp } from 'react-icons/io5';
import { MdChevronRight } from 'react-icons/md';

import { AppRoutes } from '@/constants';
import { NextLinkButton, NextLinkWrapper } from '@/modules/navigation';
import { JobOccupationsSelectorDialog } from '@/modules/shared';

type JobSearchBarProps =  CardRootProps;

export const JobSearchBar = (props: JobSearchBarProps) => {
	return (
		<Card.Root
			boxShadow="lg"
			{...props}
		>
			<Card.Body
				alignItems="center"
				display="flex"
				flexDir="row"
				gap="md"
				justifyContent="space-between"
				p={4}
			>
				<JobOccupationsSelectorDialog>
					<Button
						flex={1}
						size="sm"
						variant="outline"
					>
						Occupation
					</Button>
				</JobOccupationsSelectorDialog>
				<JobOccupationsSelectorDialog>
					<Button
						flex={1}
						size="sm"
						variant="outline"
					>
						Location
					</Button>
				</JobOccupationsSelectorDialog>
				<HStack gap="sm">
					<NextLinkButton
						href={AppRoutes.jobs.searchResults}
						size="sm"
					>
						<Icon as={IoSearchSharp} />
					</NextLinkButton>
					<NextLinkWrapper
						alignItems="center"
						color="primary.100"
						display="flex"
						href={AppRoutes.jobs.search}
					>
						Advance Search
						<MdChevronRight size={20} />
					</NextLinkWrapper>
				</HStack>
			</Card.Body>
		</Card.Root>
	);
};
